import tippy from 'tippy.js';

const hotspotsPagination = (array) => ({
  page: 1,
  disabled: false,
  handlesArray: [],
  pages: 0,
  ringingButtons: null,
  toolTip: null,
  toolTipsArray: [],
  hotspotsSections: null,
  isMobile: false,
  init(){

    this.$nextTick(() => {
      this.hotspotsSections = [...document.querySelectorAll(".hotspots-section")]
      this.handlesArray = array.split(",").filter(handle => handle !== "")
      this.pages = this.handlesArray.length + 1
      if (window.innerWidth <= 990){
        this.isMobile = true
      }

      window.addEventListener("resize", ()=>{
        this.isMobile = window.innerWidth <= 990;
      })

      if (!this.isMobile){
        this.initToolTip()
      }

      this.$watch('isMobile', (value)=>{

        if (!value){
          this.initToolTip()
        }else{
          this.destroyTooltips()
        }
      })

     /* const items = document.querySelectorAll(".hotspots-grid__item")

      if (items){
        items.forEach(item => {
          const id = item.getAttribute("variant-drawer__wrapper")
          window._swat?.initializeActionButtons("variant-drawer__wrapper")
        })
      }*/
    })
  },
  loadMore(){
    const main = document.querySelector("#MainContent")
    this.page = this.page + 1

    fetch(`/pages/${this.handlesArray[this.page - 2]}`)
      .then(res => res.text())
      .then(data => {
        const div = document.createElement("div")
        div.innerHTML = data
        main.innerHTML += div.querySelector("#MainContent").innerHTML
        if (this.page - 1 === this.handlesArray.length || this.handlesArray.length <= 1){
          this.disabled = true
        }

        if (!this.isMobile){
          this.initToolTip()
        }else{
          this.destroyTooltips()
        }
      })
  },
  initToolTip(){
    this.ringingButtons = document.querySelectorAll(".button-container")

    if (this.ringingButtons){
      this.ringingButtons.forEach(button => {
        this.toolTip = tippy(button, {
          content(reference) {
            const id = reference.getAttribute('data-template');
            if (id){
              const template = document.getElementById(id);
              return template.innerHTML;
            }
          },
          allowHTML: true,
          interactive: true,
          placement: 'bottom',
          onTrigger(instance) {
            setTimeout(()=>{
              window._swat?.initializeActionButtons("body")
            }, 100)
          }
        });
        this.toolTipsArray.push(this.toolTip)
      })
    }
  },
  destroyTooltips(){
    if (this.toolTipsArray.length > 0){
      this.toolTipsArray.forEach(tooltip => {
        tooltip.destroy()
      })

      this.toolTipsArray = []
    }
  }
});

export default hotspotsPagination;

window.addEventListener("alpine:init", ()=>{
  Alpine.data("hotspotsPagination", hotspotsPagination);
})

